<template>
  <div class="password-login-form">
    <div class="">
      <div class="left-login">
        <div class="rep-icon-login">
          <router-link
            to="/"
            class="ms-0 ps-0 login-highlight back-btn-pwd"
            >Back</router-link
          >
          <img src="../../../assets/images/group-icon.svg" alt="image-fluid" />
        </div>
        <div class="">
          <router-link to="/smart-login">
            <button class="qr-login-btn">
              <img
                src="../../../assets/images/qr-icon.svg"
                alt="qr icon"
                class="me-2"
              />Login with QR
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <h4 class="login-title mb-0">Login to Continue</h4>

    <div class="auth-form pt-3 pb-3">
      <div class="email-change-wrap">
        <div class="">{{ groupEmail }}</div>
        <div class="login-highlight" @click="goBack">Change</div>
      </div>

      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.stop.prevent="handleSubmit(handleLogin)">
          <label for="">Password<span class="required-indc mt-2"> *</span></label>
          <div class="login-password-container">
            <input-form-text
              :rules="{ required: true }"
              :customMessages="`Please enter your password`"
              labelFor=""
              labelName="Password"
              placeholder="Please enter your password"
              :inputType="passwordType"
              formGroupClass="form-group mb-1"
              @emitChanges="resetErrorMsg"
              :isErrorFlagSet="passwordErrorFlag"
              :vmodel.sync="password"
            />
            <eye-form-button
              id="password"
              hideOnDefault="false"
              :value="password"
              class="login-toggle-eye-icon"
              type="text"
              @toggle="togglePasswordVisibility"
            ></eye-form-button>

            <div class="valid-error" v-if="passwordErrorFlag && lockoutTime <= 0">
              {{ errorMsg }}
            </div>
          </div>
          <button :disabled="loginLoader || lockoutTime > 0" class="submit-btn mt-3 next-btn" type="submit">
            <b-spinner v-if="loginLoader" small></b-spinner>
            Login
          </button>
        </form>
      </ValidationObserver>
      <lockout-timer
        v-if="lockoutTime > 0"
        :lockout-seconds="lockoutTime"
        @lockout-expired="handleLockoutExpired"
      />
    </div>

    <div class="left-login mb-0">
      <div></div>
      <router-link to="/forgot-password">
        <div class="login-highlight">Forgot Password?</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputFormText from "../../../components/form/InputFormText.vue";
import EyeFormButton from "../../../components/form/EyeFormButton.vue";
import LockoutTimer from "./LockoutTimer";
import helper from "@/resource/Helper";

export default {
  name: "PasswordLoginForm",
  components: {
    InputFormText,
    EyeFormButton,
    "lockout-timer": LockoutTimer
  },
  data() {
    return {
      password: "",
      loginLoader: false,
      otpLoader: false,
      passwordErrorFlag: false,
      errorMsg: "",
      passwordType: "password",
      isPasswordVisible: true,
      lockoutTime: 0 // Tracks lockout duration from backend
    };
  },
  computed: {
    groupEmail() {
      return this.$store.getters.groupEmail;
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
      this.passwordType = this.isPasswordVisible ? "text" : "password";
    },
    handleLogin() {
      this.loginLoader = true;
      let url = process.env.VUE_APP_API_URL_V3 + `auth/login-password-validate`;
      axios.post(url, {
        email: this.$store.getters.groupEmail,
        device_id: this.$store.getters.deviceId,
        password: this.password,
      })
        .then((response) => {
          if (response.data.status === "success") {
            this.$router.push("/login-otp");
            helper.infoMessage(this, "success", response.data.message);
          }
        })
        .catch((error) => {
          this.loginLoader = false;
          if (error.response?.status === 429) { 
            const lockoutMatch = error.response.data.message?.match(/Try again after (\d+) seconds/);
            if (lockoutMatch && lockoutMatch[1]) {
              this.lockoutTime = parseInt(lockoutMatch[1], 10);
              this.passwordErrorFlag = false;
              this.errorMsg = '';
            }
          } else {
            this.passwordErrorFlag = true;
            this.errorMsg = error.response.data.message;
          }
        });
    },
    resetErrorMsg() {
      let app = this;
      app.passwordErrorFlag = false;
      app.emailErrorFlag = false;
      app.errorMsg = "";
    },
    generateOTP() {
      this.otpLoader = true;
      this.$router.push("/login-otp");
      helper.infoMessage(this, "success", "OTP has been sent.");
      this.otpLoader = false;
      this.loginLoader = false;
    },
    goBack() {
      this.$router.push({ name: "Login" });
    },
    handleLockoutExpired() {
      this.lockoutTime = 0; // Reset lockout time when timer expires
      this.passwordErrorFlag = false; // Clear error flag to hide error message
      this.errorMsg = ''; // Clear error message
    }
  },
};
</script>

<style>
.multi-step-form {
  margin: auto;
}

.multi-step-form .invalid-feedback {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.multi-step-form .step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.multi-step-form .step-indicator span {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multi-step-form .step-indicator span.active {
  background-color: #007bff;
  color: white;
}

.multi-step-form form {
  display: flex;
  flex-direction: column;
}

.multi-step-form label {
  margin-top: 10px;
}

.login-password-container {
  position: relative !important;
}

.login-toggle-eye-icon {
  position: absolute;
  top: 6px;
  right: 8px;
  cursor: pointer;
}

.login-password-container .is-valid {
  background-image: none !important;
}

.login-password-container .is-invalid {
  background-image: none !important;
}

.multi-step-form .login-signup-btn-wrap p {
  margin: 0;
  margin-top: 0.75rem;
  margin-right: 0.5rem;
}

.required-indc {
  color: #ff0000;
  font-weight: 500;
}
</style>